import type { TranslationKeys } from './en'

export const ar: TranslationKeys = {
  common: {
    welcome: 'مرحباً بعودتك',
    loading: 'جاري التحميل...',
    error: 'خطأ',
    success: 'نجاح',
    cancel: 'إلغاء',
    submit: 'إرسال',
    save: 'حفظ',
    delete: 'حذف',
    edit: 'تعديل',
    view: 'عرض',
    viewAll: 'عرض الكل',
    download: 'تحميل',
    share: 'مشاركة',
    close: 'إغلاق',
    back: 'رجوع',
    next: 'التالي',
    send: 'إرسال',
    search: 'بحث',
    noResults: 'لا توجد نتائج',
    daysLeft: 'أيام متبقية',
    justNow: 'الآن',
    hoursAgo: 'س',
    daysAgo: 'ي',
  },
  auth: {
    login: 'تسجيل الدخول',
    logout: 'تسجيل الخروج',
    phoneNumber: 'رقم الهاتف',
    enterPhone: 'أدخل رقم هاتفك',
    phonePlaceholder: '+971 50 XXX XXXX',
    sendOtp: 'إرسال رمز التحقق',
    enterOtp: 'أدخل رمز التحقق',
    otpSent: 'تم إرسال رمز التحقق إلى هاتفك',
    verify: 'تحقق',
    verifying: 'جاري التحقق...',
    resendOtp: 'إعادة إرسال الرمز',
    resendIn: 'إعادة الإرسال خلال',
    seconds: 'ثانية',
    invalidOtp: 'رمز التحقق غير صحيح',
    otpExpired: 'انتهت صلاحية الرمز. يرجى إعادة الإرسال.',
    welcomeTitle: 'مرحباً بك في',
    appName: 'بوابة العقارات',
    welcomeSubtitle: 'سجل دخولك للوصول إلى لوحة التحكم الخاصة بك',
  },
  navigation: {
    home: 'الرئيسية',
    properties: 'العقارات',
    payments: 'المدفوعات',
    support: 'الدعم',
    more: 'المزيد',
  },
  dashboard: {
    welcome: 'مرحباً بعودتك',
    myProperties: 'عقاراتي',
    avgProgress: 'متوسط التقدم',
    latestAnnouncement: 'آخر الإعلانات',
    nextPaymentDue: 'الدفعة القادمة',
    overallConstruction: 'تقدم البناء الإجمالي',
    avgProgressDesc: 'متوسط التقدم عبر جميع عقاراتك',
  },
  properties: {
    title: 'العقارات',
    unitSpecifications: 'مواصفات الوحدة',
    documents: 'المستندات',
    files: 'ملفات',
    unitId: 'رقم الوحدة',
    floor: 'الطابق',
    area: 'المساحة',
    project: 'المشروع',
    constructionProgress: 'تقدم البناء',
    nextInstallment: 'القسط التالي',
  },
  construction: {
    title: 'تقدم البناء',
    subtitle: 'تتبع تقدم البناء في الوقت الفعلي',
    projectProgress: 'تقدم المشروع',
    myUnitProgress: 'تقدم وحدتي',
    completion: 'الإنجاز',
    complete: 'مكتمل',
    milestones: 'المراحل',
    sitePhotos: 'صور الموقع',
    photos: 'صور',
    completed: 'مكتمل',
    expected: 'متوقع',
  },
  payments: {
    title: 'سجل المدفوعات',
    subtitle: 'تتبع وإدارة أقساطك',
    totalPaid: 'إجمالي المدفوع',
    pending: 'قيد الانتظار',
    all: 'الكل',
    paid: 'مدفوع',
    upcoming: 'قادم',
    overdue: 'متأخر',
    overdueAlert: 'دفعة متأخرة',
    overdueAlertPlural: 'دفعات متأخرة',
    overdueMessage: 'يرجى الدفع الآن أو تحميل إثبات الدفع لتجنب الغرامات',
    payNow: 'ادفع الآن',
    uploadProof: 'تحميل الإثبات',
    uploadPaymentProof: 'تحميل إثبات الدفع',
    transactionRef: 'رقم المرجع',
    enterBankRef: 'أدخل رقم مرجع البنك',
    uploadReceipt: 'تحميل الإيصال',
    selectFile: 'اختر ملف',
    submitProof: 'إرسال الإثبات',
    payWithVisa: 'الدفع بالفيزا',
    amountToPay: 'المبلغ المستحق',
    cardNumber: 'رقم البطاقة',
    cardholderName: 'اسم حامل البطاقة',
    expiryMonth: 'شهر الانتهاء',
    expiryYear: 'سنة الانتهاء',
    cvv: 'CVV',
    securePayment: 'دفعتك مؤمنة بتشفير SSL 256-bit',
    paymentSuccessful: 'تم الدفع بنجاح!',
    paymentProcessed: 'تمت معالجة دفعتك بنجاح.',
  },
  support: {
    title: 'تذاكر الدعم',
    subtitle: 'احصل على المساعدة في استفساراتك العقارية',
    open: 'مفتوح',
    resolved: 'تم الحل',
    new: 'جديد',
    inProgress: 'قيد المعالجة',
    createTicket: 'إنشاء تذكرة جديدة',
    category: 'الفئة',
    selectCategory: 'اختر الفئة',
    subject: 'الموضوع',
    subjectPlaceholder: 'وصف موجز لمشكلتك',
    description: 'الوصف',
    descriptionPlaceholder: 'قدم تفاصيل حول طلبك...',
    submitTicket: 'إرسال التذكرة',
    ticketResolved: 'تم حل هذه التذكرة',
    createNewTicket: 'إذا كنت بحاجة إلى مساعدة إضافية، يرجى إنشاء تذكرة جديدة',
    responseTime: 'يرد فريق الدعم عادةً خلال 24 ساعة',
    sendReply: 'إرسال الرد',
    typeReply: 'اكتب ردك...',
    categories: {
      payments: 'المدفوعات',
      property: 'العقار',
      siteVisit: 'زيارة الموقع',
      documents: 'المستندات',
      account: 'الحساب',
      other: 'أخرى',
    },
  },
  discovery: {
    title: 'اكتشف المشاريع',
    subtitle: 'استكشف فرص الاستثمار الجديدة',
    searchPlaceholder: 'ابحث بالمشروع أو الموقع...',
    noProjects: 'لا توجد مشاريع',
    interested: 'أنا مهتم',
    expressInterest: 'إبداء الاهتمام',
    interestSubmitted: 'تم إرسال اهتمامك!',
    salesContact: 'سيتواصل معك فريق المبيعات خلال 24 ساعة.',
    fullName: 'الاسم الكامل',
    email: 'البريد الإلكتروني',
    message: 'رسالة (اختياري)',
    messagePlaceholder: 'أي متطلبات أو أسئلة محددة؟',
    submitInterest: 'إرسال الاهتمام',
    startingFrom: 'يبدأ من',
    units: 'وحدات',
    completion: 'الإنجاز',
  },
  referral: {
    title: 'برنامج الإحالة',
    subtitle: 'اكسب مكافآت بإحالة الأصدقاء والعائلة',
    earnReward: 'اكسب 10,000 درهم',
    rewardDesc: 'لكل إحالة ناجحة تنتهي بصفقة',
    totalReferrals: 'إجمالي الإحالات',
    successful: 'ناجحة',
    submitReferral: 'إرسال إحالة جديدة',
    referralName: 'الاسم الكامل',
    referralNamePlaceholder: 'أدخل اسم المُحال',
    referralPhone: 'رقم الهاتف',
    referralEmail: 'البريد الإلكتروني (اختياري)',
    submitReferralBtn: 'إرسال الإحالة',
    pipeline: 'مسار الإحالات',
    yourReferrals: 'إحالاتك',
    stages: {
      newLead: 'عميل جديد',
      contacted: 'تم التواصل',
      siteVisit: 'زيارة الموقع',
      negotiation: 'التفاوض',
      dealWon: 'صفقة ناجحة',
    },
  },
  announcements: {
    important: 'مهم',
    urgent: 'عاجل',
    info: 'معلومات',
    forQuestions: 'للاستفسارات، تواصل مع فريق الدعم',
  },
  language: {
    english: 'English',
    arabic: 'العربية',
    switchTo: 'التبديل إلى',
  },
}
